export const CONNECT_SOCKET = 'CONNECT_SOCKET';
export const DISCONNECT_SOCKET = 'DISCONNECT_SOCKET';
export const RECEIVE_TRANSACTION_UPDATE = 'RECEIVE_TRANSACTION_UPDATE';
export const SUBSCRIBE_TO_TRANSACTION = 'SUBSCRIBE_TO_TRANSACTION';
export const SUBSCRIBE_TO_ORGANIZATION = 'SUBSCRIBE_TO_ORGANIZATION';
export const UNSUBSCRIBE = 'UNSUBSCRIBE';

export const connectSocket = () => ({ type: CONNECT_SOCKET });
export const disconnectSocket = () => ({ type: DISCONNECT_SOCKET });

export const receiveTransactionUpdate = message => ({
  type: RECEIVE_TRANSACTION_UPDATE,
  payload: message
});

export const subscribeToTransaction = transactionId => ({
  type: SUBSCRIBE_TO_TRANSACTION,
  payload: transactionId
});

export const subscribeToOrganization = organizationId => ({
  type: SUBSCRIBE_TO_ORGANIZATION,
  payload: organizationId
});

export const unsubscribe = room => ({ type: UNSUBSCRIBE, payload: room });
